import { toast } from "react-toastify";

export default function toastFile(action, type) {
  switch (action) {
    case "new":
      toast.success("Successful");
      break;
    case "update":
      toast.success("Updated");
      break;
    case "delete":
      toast.success("Deleted");
      break;
    case "create":
      toast.success("Created");
      break;
    case "deleteall":
      toast.success("All Record Deleted");
      break;
    case "invalid file":
      toast.error("Invalid File Format");
      break;
    case "imported":
      toast.success("Imported Successfully");
      break;
    case "Select Client":
      toast.warn("Please select a client");
      break;
    case "Region Rejected":
      toast.error("Requested region is rejected");
      break;
    case "File Uploaded":
      toast.success("File uploaded successfully");
      break;
    case "File Not Uploaded":
      toast.error("Failed to upload");
      break;
    case "calculation true":
      toast.success(
        "Plan AV and deviation calculation has been successfully updated"
      );
      break;
    case "calculation false":
      toast.error(
        "Please fill in all intended metal tiers and acturial plan values and try again."
      );
      break;
    case "Client Name Not Match":
      toast.error(
        "Client name in the import file does not match the client name selected,Please correct and then try again"
      );
      break;
    case "plan not found":
      toast.error(
        "Please update the Plan AV & Deviation Calculation, and then try again"
      );
      break;
    case "email not match":
      toast.error(
        "Account is not authorized. Please contact HUB International for assistance."
      );
      break;
    case "bidderemail":
      toast.error("Email already exists");
      break;
    case "something wrong":
      toast.error("Something went wrong.");
      break;
    case "SubmitButton":
      toast.success("Submitted Successfully");
      break;
    case "Completed":
      toast.success("Completed");
      break;
    case "failed":
      toast.error("failed");
      break;
    default:
      if (type === "success") {
        toast.success(action);
      } else if (type === "warning") {
        toast.warning(action);
      } else {
        toast.error(action);
      }
  }
}
